// Хранилище для zustand/persist, которое не роняет витрину.
//
// persist пишет в localStorage на КАЖДЫЙ set(). Когда браузер отказывает в
// записи (Safari в приватном режиме, переполненная квота, запрет сайтовых
// данных), setItem бросает исключение — и оно вылетает из set() прямо в
// обработчик клика. Так «Сохранить» в настройке ленты не закрывал панель и
// не применял фильтры, а сердечко не доходило до сервера: вызов записи лайка
// стоит после set(). Здесь ошибки хранилища гасятся: состояние живёт в памяти
// до перезагрузки, а сервер остаётся источником истины для избранного.
import type { StateStorage } from "zustand/middleware";

const storage = (): Storage | null => {
	try {
		return typeof window !== "undefined" ? window.localStorage : null;
	} catch {
		return null;
	}
};

export const safeLocalStorage: StateStorage = {
	getItem: (name) => {
		try {
			return storage()?.getItem(name) ?? null;
		} catch {
			return null;
		}
	},
	setItem: (name, value) => {
		try {
			storage()?.setItem(name, value);
		} catch {
			// квота/запрет — остаёмся на состоянии в памяти
		}
	},
	removeItem: (name) => {
		try {
			storage()?.removeItem(name);
		} catch {
			// нечего удалять — не страшно
		}
	},
};
